/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { isNotEmpty } from "~/tools";

export function getNumberFilterValue(value: string): number | undefined {
  return isNotEmpty(value) ? Number(value) : undefined;
}
